import React, { useContext, useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import {
  FormInputTooltip,
  FormInputTooltipBubble
} from 'src/components/atoms/FormInputTooltipBubble'
import moment from 'moment'
import { useIntl, Link } from 'gatsby-plugin-intl'
import useValidateSchema from 'src/hooks/useValidateSchema'
import { compose } from 'recompose'
import { breakpoint } from 'src/theme/grid'
import { scrollToRef } from 'src/utils/scroll'
import HeaderLoggedIn, {
  HeaderGroup
} from 'src/components/header/HeaderLoggedIn'
import { Page } from 'src/components/Wrappers'
import BreadCrumbs from 'src/components/BreadCrumbs'
import { MENU_ITEMS } from 'src/features/dashboard/duck/consts'
import LocationInput from 'src/components/filters/LocationInput'
import routes from 'src/utils/routes'
import { connectDictionaries } from 'src/ducks/connectors'
import Checkbox from 'src/components/atoms/CheckboxInput'
import Select from 'src/components/filters/SelectInput'
import TextInput from 'src/components/atoms/TextInput'
import TextInputMasked from 'src/components/atoms/TextInputMasked'
import DatePicker from 'src/components/atoms/DatePicker'
import Alert from 'src/components/Alert'
import {
  BOOLEAN,
  LOCATION_TYPES,
  API_STATES,
  EXCHANGE_API_URL_PREFIXES
} from 'src/ducks/consts'
import { EURO_OPTIONS } from 'src/features/stocks/ducks/consts'
import {
  OFFER_TYPES,
  OFFER_TYPES_OPTIONS,
  OFFER_VISIBILITY_TYPES,
  OFFER_VISIBILITY_TYPES_OPTIONS
} from 'src/features/offers/duck/consts'
import IconWithTooltip from 'src/components/IconWithTooltip'
import NewForeignLocationsAddedAlert from 'src/features/offers/components/NewForeignLocationsAddedAlert'
import PermissionsContext from 'src/utils/permissions'
import PrivateOfferCreateOptions from 'src/features/offers/components/PrivateOfferCreateOptions'
import { useSelector } from 'react-redux'
import { canAddOffer } from 'src/features/offers/utils/exchangePermissions'
import CreateOfferMenu from './components/CreateOfferMenu'
import {
  Content,
  FormSection,
  FormInnerWrapper,
  FormSectionSpacer,
  FormActionBar,
  InputsRowWrapper,
  InputWrapper,
  FormSubsectionSpacer,
  PlaceInputWrapper,
  DateInputWrapper,
  TimeInputWrapper,
  DictionaryInputWrapper,
  WeightInputWrapper,
  PriceInputWrapper,
  CargoTypeInputWrapper,
  CheckboxInputWrapper,
  Padding,
  TemplateNameInputWrapper,
  TemplatesButton,
  ActionGroup,
  HideOnMobile,
  RadioWrapper,
  WarningWrapper,
  AuctionTimeInputWrapper,
  AuctionNotesWrapper
} from './components/atoms'
import Drafts from './components/Drafts'
import { FormNavigationHeader } from './components/typography'
import connect from './duck/connectors'
import CheckboxSection from './components/CheckboxSection'
import { validateOfferGeneral, validateOfferGeneralSchema } from './duck/schema'

const OfferFormGeneralCargo = ({
  className,
  offerFormGeneral,
  setOfferFormGeneralValue,
  clearGeneralOfferForm,
  fetchLocations,
  loadingDictionary,
  unloadingDictionary,
  dictionaries,
  destinationDictionary,
  getGeneralMyCompanyLastOffers,
  getGeneralOfferTemplates,
  lastOffersGeneral,
  offerTemplatesGeneral,
  fillFormUsingTemplateGeneral,
  removeTemplateGeneral,

  createGeneralOffer,
  createBulkGeneralOffers,
  createAndDuplicateGeneralOffer,
  createAndStartNewGeneralOffer
}) => {
  const intl = useIntl()
  const templateRef = useRef(null)
  const formContentRef = useRef(null)
  const permissions = useContext(PermissionsContext)
  const currentUser = useSelector(state => state.account.currentUser)
  const canCreatePublicOffer = canAddOffer(
    EXCHANGE_API_URL_PREFIXES.GENERAL,
    permissions,
    OFFER_VISIBILITY_TYPES.PUBLIC
  )
  const canCreatePrivateOffer = canAddOffer(
    EXCHANGE_API_URL_PREFIXES.GENERAL,
    permissions,
    OFFER_VISIBILITY_TYPES.PRIVATE
  )
  const visibilityOptions = OFFER_VISIBILITY_TYPES_OPTIONS.map(option => ({
    ...option,
    text: intl.formatMessage({ id: option.text })
  }))
  const availableVisibilityOptions = visibilityOptions.filter(option =>
    option.value === OFFER_VISIBILITY_TYPES.PUBLIC
      ? canCreatePublicOffer
      : canCreatePrivateOffer
  )
  const hasAvailableVisibilityOptions = availableVisibilityOptions.length > 0
  const shouldShowVisibilitySelector = availableVisibilityOptions.length > 1

  const [templatesOpened, setTemplatesOpened] = useState(false)
  const valid = useValidateSchema(
    offerFormGeneral.toJS(),
    validateOfferGeneralSchema
  )

  useEffect(() => {
    let defaultVisibility = null

    if (currentUser?.isPrivateOfferDefault && canCreatePrivateOffer) {
      defaultVisibility = OFFER_VISIBILITY_TYPES.PRIVATE
    } else if (canCreatePublicOffer) {
      defaultVisibility = OFFER_VISIBILITY_TYPES.PUBLIC
    } else if (canCreatePrivateOffer) {
      defaultVisibility = OFFER_VISIBILITY_TYPES.PRIVATE
    }

    setOfferFormGeneralValue('visibility', defaultVisibility)
  }, [
    canCreatePrivateOffer,
    canCreatePublicOffer,
    currentUser?.isPrivateOfferDefault,
    setOfferFormGeneralValue
  ])

  useEffect(() => {
    if (offerFormGeneral.visibility !== OFFER_VISIBILITY_TYPES.PRIVATE) {
      setOfferFormGeneralValue('rooms', null)
      setOfferFormGeneralValue('goPublicAt', null)
    }
  }, [offerFormGeneral.visibility, setOfferFormGeneralValue])

  useEffect(() => {
    getGeneralMyCompanyLastOffers()
    getGeneralOfferTemplates()
    return clearGeneralOfferForm
  }, [])

  const isAuction = offerFormGeneral.type === OFFER_TYPES.AUCTION

  return (
    <Page
      className={className}
      contentPadding={0}
      topBar={
        <HeaderLoggedIn>
          <HeaderGroup>
            <FormNavigationHeader>
              {`${intl.formatMessage({
                id: 'forms.addOffer'
              })} - ${intl.formatMessage({
                id: 'offers.generalCargoExchangeTitle'
              })}`}
            </FormNavigationHeader>
          </HeaderGroup>
        </HeaderLoggedIn>
      }
    >
      <Content>
        <FormSection>
          <FormInnerWrapper ref={formContentRef}>
            <Padding>
              <BreadCrumbs
                links={[
                  {
                    name: intl.formatMessage({ id: 'forms.dashboard' }),
                    url: `${routes.APP_DASHBOARD}?tab=${MENU_ITEMS.DASHBOARD}`
                  },
                  {
                    name: intl.formatMessage({
                      id: 'offers.generalCargoExchangeTitle'
                    }),
                    url: `${routes.APP_DASHBOARD}?tab=${MENU_ITEMS.STOCKS_GENERAL}`
                  },
                  {
                    name: intl.formatMessage({ id: 'forms.addOffer' }),
                    url: null
                  }
                ]}
              />
              <TemplatesButton onClick={() => setTemplatesOpened(true)}>
                {intl.formatMessage({ id: 'forms.copyOrUseTemplate' })}
              </TemplatesButton>
              <NewForeignLocationsAddedAlert />
              <FormSectionSpacer>
                <RadioWrapper>
                  <div>{intl.formatMessage({ id: 'forms.offerType' })}</div>
                  {OFFER_TYPES_OPTIONS.map(option => ({
                    ...option,
                    text: intl.formatMessage({ id: option.text })
                  })).map(opt => (
                    <Checkbox
                      key={opt.value}
                      name='type'
                      value={offerFormGeneral.type}
                      onChange={setOfferFormGeneralValue}
                      type='radio'
                      option={opt}
                    />
                  ))}
                </RadioWrapper>
              </FormSectionSpacer>
              {isAuction && (
                <>
                  <WarningWrapper>
                    <Alert
                      message={intl.formatMessage({
                        id: 'forms.auctionWarning'
                      })}
                      type='info'
                    />
                  </WarningWrapper>
                  <InputsRowWrapper>
                    <DateInputWrapper>
                      <DatePicker
                        label={intl.formatMessage({
                          id: 'forms.auctionEndDate'
                        })}
                        disablePast
                        required
                        name='auctionDeadlineDate'
                        placeholder='dd.mm.rrrr'
                        value={offerFormGeneral.auctionDeadlineDate}
                        onChange={setOfferFormGeneralValue}
                        maxDate={moment().add(6, 'days')}
                      />
                    </DateInputWrapper>
                    <AuctionTimeInputWrapper>
                      <TextInputMasked
                        mask='99:99'
                        label={intl.formatMessage({
                          id: 'forms.auctionEndTime'
                        })}
                        required
                        id='auctionDeadlineTime'
                        name='auctionDeadlineTime'
                        placeholder='gg:mm'
                        value={offerFormGeneral.auctionDeadlineTime}
                        onChange={setOfferFormGeneralValue}
                        validate={validateOfferGeneral}
                        type='tel'
                        calendarTime
                      />
                    </AuctionTimeInputWrapper>
                    <PriceInputWrapper>
                      <TextInput
                        label={intl.formatMessage({
                          id: 'forms.auctionBasePrice'
                        })}
                        id='price'
                        name='price'
                        required
                        placeholder=''
                        value={offerFormGeneral.price}
                        onChange={setOfferFormGeneralValue}
                        validate={validateOfferGeneral}
                        type='currency'
                        onCurrencyChange={setOfferFormGeneralValue}
                        currencyValue={offerFormGeneral.currency}
                      />
                    </PriceInputWrapper>
                    <Checkbox
                      name='isPriceVisible'
                      value={offerFormGeneral.isPriceVisible}
                      option={{
                        value: BOOLEAN.YES,
                        text: intl.formatMessage({
                          id: 'forms.isPriceVisible'
                        })
                      }}
                      onChange={name => {
                        setOfferFormGeneralValue(
                          name,
                          !offerFormGeneral.isPriceVisible
                        )
                      }}
                    />
                    <AuctionNotesWrapper>
                      <TextInput
                        label={intl.formatMessage({
                          id: 'forms.auctionNotes'
                        })}
                        id='notes'
                        name='notes'
                        multiline
                        rows={3}
                        placeholder={intl.formatMessage({
                          id: 'forms.auctionNotesPlaceholder'
                        })}
                        value={offerFormGeneral.notes}
                        onChange={setOfferFormGeneralValue}
                        validate={validateOfferGeneral}
                      />
                    </AuctionNotesWrapper>
                  </InputsRowWrapper>
                </>
              )}
              {shouldShowVisibilitySelector && (
                <>
                  <FormSectionSpacer>
                    <RadioWrapper>
                      <div>
                        {intl.formatMessage({ id: 'offersFilters.visibility' })}
                      </div>
                      {availableVisibilityOptions.map(opt => (
                        <React.Fragment key={opt.value}>
                          <Checkbox
                            name='visibility'
                            value={offerFormGeneral.visibility}
                            onChange={setOfferFormGeneralValue}
                            type='radio'
                            option={opt}
                          />
                          {opt.value === OFFER_VISIBILITY_TYPES.PRIVATE && (
                            <IconWithTooltip
                              title={intl.formatMessage({
                                id: 'forms.privateOfferCreateOptionsInfoMessage'
                              })}
                            />
                          )}
                        </React.Fragment>
                      ))}
                    </RadioWrapper>
                  </FormSectionSpacer>
                </>
              )}
              {!hasAvailableVisibilityOptions && (
                <Alert
                  message={intl.formatMessage({
                    id: 'forms.offerVisibilityNoPermissions'
                  })}
                  type='warning'
                />
              )}
              {offerFormGeneral.visibility ===
                OFFER_VISIBILITY_TYPES.PRIVATE && (
                <PrivateOfferCreateOptions
                  exchangeType={EXCHANGE_API_URL_PREFIXES.GENERAL}
                  onGoPublicDateTimeChange={setOfferFormGeneralValue}
                  rooms={offerFormGeneral.rooms}
                  canCreatePublicOffer={canCreatePublicOffer}
                />
              )}
              <FormSectionSpacer>
                {intl.formatMessage({ id: 'forms.tracking' })}
                <IconWithTooltip
                  openTime={3000}
                  title={intl.formatMessage({
                    id: 'forms.trackingHelperForwarder'
                  })}
                />
              </FormSectionSpacer>
              <Checkbox
                name='doesRequireTracking'
                value={offerFormGeneral.doesRequireTracking}
                option={{
                  value: BOOLEAN.YES,
                  text: intl.formatMessage({
                    id: 'forms.doesRequireTrackingForwarder'
                  })
                }}
                onChange={name => {
                  setOfferFormGeneralValue(
                    name,
                    !offerFormGeneral.doesRequireTracking
                  )
                }}
              />
              <FormSectionSpacer>
                {intl.formatMessage({ id: 'forms.loadingSectionName' })}
              </FormSectionSpacer>
              <InputsRowWrapper>
                <PlaceInputWrapper>
                  <LocationInput
                    required
                    id='loadingLocationId'
                    label={intl.formatMessage({
                      id: 'forms.loadingPlaceInputLabel'
                    })}
                    locationName='loadingLocationId'
                    locationValue={offerFormGeneral.loadingLocationId}
                    locationPlaceholder={intl.formatMessage({
                      id: 'forms.loadingPlaceInputLabel'
                    })}
                    onChange={(name, value) =>
                      setOfferFormGeneralValue(name, value)
                    }
                    placeholder={intl.formatMessage({
                      id: 'forms.locationPlaceholder'
                    })}
                    locationTypes={LOCATION_TYPES.CITY}
                    dictionary={loadingDictionary}
                    isLoading={
                      loadingDictionary.state === API_STATES.IN_PROGRESS
                    }
                    fetchLocations={fetchLocations}
                    searchHintText={intl.formatMessage({
                      id: 'offersFilters.searchHintText'
                    })}
                  />
                </PlaceInputWrapper>
                <DateInputWrapper>
                  <DatePicker
                    label={intl.formatMessage({
                      id: 'forms.loadingDateInputLabel'
                    })}
                    disablePast
                    required
                    name='loadingDate'
                    placeholder='dd.mm.rrrr'
                    value={offerFormGeneral.loadingDate}
                    onChange={setOfferFormGeneralValue}
                    maxDate={offerFormGeneral.unloadingDate}
                  />
                </DateInputWrapper>
                <TimeInputWrapper>
                  <TextInputMasked
                    mask='99:99'
                    label={intl.formatMessage({
                      id: 'forms.loadingTimeInputLabel'
                    })}
                    id='loadingTime'
                    name='loadingTime'
                    placeholder='gg:mm'
                    value={offerFormGeneral.loadingTime}
                    onChange={setOfferFormGeneralValue}
                    validate={validateOfferGeneral}
                    type='tel'
                    calendarTime
                  />
                </TimeInputWrapper>
              </InputsRowWrapper>
              <FormSectionSpacer>
                {intl.formatMessage({ id: 'forms.unloadingSectionName' })}
              </FormSectionSpacer>
              <InputsRowWrapper>
                <PlaceInputWrapper>
                  <LocationInput
                    required
                    id='unloadingLocationId'
                    label={intl.formatMessage({
                      id: 'forms.unloadingPlaceInputLabel'
                    })}
                    locationName='unloadingLocationId'
                    locationValue={offerFormGeneral.unloadingLocationId}
                    locationPlaceholder={intl.formatMessage({
                      id: 'forms.unloadingPlaceInputLabel'
                    })}
                    onChange={(name, value) =>
                      setOfferFormGeneralValue(name, value)
                    }
                    placeholder={intl.formatMessage({
                      id: 'forms.locationPlaceholder'
                    })}
                    locationTypes={LOCATION_TYPES.CITY}
                    dictionary={unloadingDictionary}
                    isLoading={
                      unloadingDictionary.state === API_STATES.IN_PROGRESS
                    }
                    fetchLocations={fetchLocations}
                    searchHintText={intl.formatMessage({
                      id: 'offersFilters.searchHintText'
                    })}
                  />
                </PlaceInputWrapper>
                <DateInputWrapper>
                  <DatePicker
                    label={intl.formatMessage({
                      id: 'forms.unloadingDateInputLabel'
                    })}
                    disablePast
                    required
                    name='unloadingDate'
                    placeholder='dd.mm.rrrr'
                    value={offerFormGeneral.unloadingDate}
                    onChange={setOfferFormGeneralValue}
                    minDate={offerFormGeneral.loadingDate}
                  />
                </DateInputWrapper>
                <TimeInputWrapper>
                  <TextInputMasked
                    mask='99:99'
                    label={intl.formatMessage({
                      id: 'forms.unloadingTimeInputLabel'
                    })}
                    id='unloadingTime'
                    name='unloadingTime'
                    placeholder='gg:mm'
                    value={offerFormGeneral.unloadingTime}
                    onChange={setOfferFormGeneralValue}
                    validate={validateOfferGeneral}
                    type='tel'
                    calendarTime
                  />
                </TimeInputWrapper>
              </InputsRowWrapper>
              <FormSectionSpacer>
                {intl.formatMessage({ id: 'forms.cargoSectionName' })}
              </FormSectionSpacer>
              <InputsRowWrapper>
                <DictionaryInputWrapper>
                  <Select
                    required
                    id='containerId'
                    name='containerId'
                    label={intl.formatMessage({ id: 'forms.container' })}
                    value={offerFormGeneral.containerId}
                    options={dictionaries.containers}
                    onChange={setOfferFormGeneralValue}
                    placeholder={intl.formatMessage({
                      id: 'forms.searchPlaceholder'
                    })}
                  />
                </DictionaryInputWrapper>
                <WeightInputWrapper>
                  <TextInput
                    label={intl.formatMessage({ id: 'forms.weight' })}
                    id='weight'
                    name='weight'
                    placeholder={intl.formatMessage({
                      id: 'forms.weight'
                    })}
                    value={offerFormGeneral.weight}
                    onChange={setOfferFormGeneralValue}
                    validate={validateOfferGeneral}
                    type='unit'
                    unit='kg'
                  />
                  {!offerFormGeneral.weight && (
                    <FormInputTooltip>
                      <FormInputTooltipBubble>
                        <span role='img' aria-hidden='true'>
                          💡
                        </span>{' '}
                        {intl.formatMessage({ id: 'forms.weightHelpText' })}
                      </FormInputTooltipBubble>
                    </FormInputTooltip>
                  )}
                </WeightInputWrapper>
                <CargoTypeInputWrapper>
                  <Select
                    id='cargoTypeId'
                    name='cargoTypeId'
                    label={intl.formatMessage({ id: 'forms.cargoType' })}
                    value={offerFormGeneral.cargoTypeId}
                    options={dictionaries.cargoTypes}
                    onChange={setOfferFormGeneralValue}
                    placeholder={intl.formatMessage({
                      id: 'forms.searchPlaceholder'
                    })}
                  />
                </CargoTypeInputWrapper>
              </InputsRowWrapper>
              <InputsRowWrapper>
                <DictionaryInputWrapper>
                  <Select
                    id='adrClassId'
                    name='adrClassId'
                    label={intl.formatMessage({ id: 'forms.adrClass' })}
                    value={offerFormGeneral.adrClassId}
                    options={dictionaries.adrClasses}
                    onChange={setOfferFormGeneralValue}
                    placeholder={intl.formatMessage({
                      id: 'forms.searchPlaceholder'
                    })}
                    width='380px'
                  />
                </DictionaryInputWrapper>
                <DictionaryInputWrapper>
                  <Select
                    id='europeanEmissionStandard'
                    name='europeanEmissionStandard'
                    label={intl.formatMessage({
                      id: 'forms.europeanEmissionStandard'
                    })}
                    value={offerFormGeneral.europeanEmissionStandard}
                    options={EURO_OPTIONS.map(option => ({
                      ...option,
                      label: intl.formatMessage({ id: option.label })
                    }))}
                    onChange={setOfferFormGeneralValue}
                    placeholder={intl.formatMessage({
                      id: 'forms.searchPlaceholder'
                    })}
                    width='230px'
                  />
                </DictionaryInputWrapper>
              </InputsRowWrapper>
              <InputsRowWrapper>
                <CheckboxInputWrapper>
                  <Checkbox
                    name='isSentRequired'
                    value={offerFormGeneral.isSentRequired}
                    option={{
                      value: BOOLEAN.YES,
                      text: intl.formatMessage({ id: 'offersFilters.sent' })
                    }}
                    onChange={name =>
                      setOfferFormGeneralValue(
                        name,
                        !offerFormGeneral.isSentRequired
                      )
                    }
                  />
                </CheckboxInputWrapper>
                <CheckboxInputWrapper>
                  <Checkbox
                    name='isLine'
                    value={offerFormGeneral.isLine}
                    option={{
                      value: BOOLEAN.YES,
                      text: intl.formatMessage({ id: 'offersFilters.line' })
                    }}
                    onChange={name =>
                      setOfferFormGeneralValue(name, !offerFormGeneral.isLine)
                    }
                  />
                </CheckboxInputWrapper>
              </InputsRowWrapper>
              <FormSubsectionSpacer>
                {intl.formatMessage({ id: 'forms.additionalCargoInformation' })}
              </FormSubsectionSpacer>
              <InputsRowWrapper>
                {!isAuction && (
                  <PriceInputWrapper>
                    <TextInput
                      label={intl.formatMessage({ id: 'forms.price' })}
                      id='price'
                      name='price'
                      placeholder={intl.formatMessage({ id: 'forms.price' })}
                      value={offerFormGeneral.price}
                      onChange={setOfferFormGeneralValue}
                      validate={validateOfferGeneral}
                      type='currency'
                      onCurrencyChange={setOfferFormGeneralValue}
                      currencyValue={offerFormGeneral.currency}
                    />
                  </PriceInputWrapper>
                )}
              </InputsRowWrapper>
            </Padding>
            <CheckboxSection
              opened={offerFormGeneral.customsClearanceLocationIdOpened}
              setOpened={opened =>
                setOfferFormGeneralValue(
                  'customsClearanceLocationIdOpened',
                  opened
                )
              }
              label={intl.formatMessage({
                id: 'forms.customsClearance'
              })}
              handleClose={() =>
                setOfferFormGeneralValue('customsClearanceLocationId', null)
              }
            >
              <PlaceInputWrapper>
                <LocationInput
                  required
                  id='customsClearanceLocationId'
                  label={intl.formatMessage({
                    id: 'forms.customsClearanceLocationLabel'
                  })}
                  locationName='customsClearanceLocationId'
                  locationValue={offerFormGeneral.customsClearanceLocationId}
                  locationPlaceholder={intl.formatMessage({
                    id: 'forms.customsClearanceLocationLabel'
                  })}
                  onChange={(name, value) =>
                    setOfferFormGeneralValue(name, value)
                  }
                  placeholder={intl.formatMessage({
                    id: 'forms.locationPlaceholder'
                  })}
                  locationTypes={LOCATION_TYPES.CITY}
                  dictionary={destinationDictionary}
                  isLoading={
                    destinationDictionary.state === API_STATES.IN_PROGRESS
                  }
                  fetchLocations={fetchLocations}
                  searchHintText={intl.formatMessage({
                    id: 'offersFilters.searchHintText'
                  })}
                />
              </PlaceInputWrapper>
            </CheckboxSection>
            {!isAuction && (
              <Padding>
                <FormSectionSpacer>
                  {intl.formatMessage({ id: 'forms.additionalInformation' })}
                </FormSectionSpacer>
                <InputsRowWrapper>
                  <InputWrapper>
                    <TextInput
                      label={intl.formatMessage({
                        id: 'forms.additionalInformation'
                      })}
                      id='notes'
                      name='notes'
                      multiline
                      rows={3}
                      placeholder={intl.formatMessage({
                        id: 'forms.additionalInformationPlaceholder'
                      })}
                      value={offerFormGeneral.notes}
                      onChange={setOfferFormGeneralValue}
                      validate={validateOfferGeneral}
                    />
                  </InputWrapper>
                </InputsRowWrapper>
                <FormSectionSpacer />
              </Padding>
            )}
            <CheckboxSectionStyled
              ref={templateRef}
              opened={offerFormGeneral.templateNameOpened}
              setOpened={opened =>
                setOfferFormGeneralValue('templateNameOpened', opened)
              }
              label={intl.formatMessage({
                id: 'forms.templateName'
              })}
              handleClose={() => setOfferFormGeneralValue('templateName', null)}
            >
              <TemplateNameInputWrapper>
                <TextInput
                  required
                  label={intl.formatMessage({
                    id: 'forms.templateNameLabel'
                  })}
                  id='templateName'
                  name='templateName'
                  placeholder={intl.formatMessage({
                    id: 'forms.templateNamePlaceholder'
                  })}
                  value={offerFormGeneral.templateName}
                  onChange={setOfferFormGeneralValue}
                  validate={validateOfferGeneral}
                />
              </TemplateNameInputWrapper>
            </CheckboxSectionStyled>
          </FormInnerWrapper>
          <FormActionBar>
            <Link
              to={`${routes.APP_DASHBOARD}?tab=${MENU_ITEMS.STOCKS_GENERAL}`}
            >
              {intl.formatMessage({ id: 'forms.cancel' })}
            </Link>
            <ActionGroup>
              <HideOnMobile>
                <Checkbox
                  name='templateNameOpened'
                  value={offerFormGeneral.templateNameOpened}
                  option={{
                    value: BOOLEAN.YES,
                    text: intl.formatMessage({
                      id: 'forms.templateName'
                    })
                  }}
                  onChange={name => {
                    setOfferFormGeneralValue(
                      name,
                      !offerFormGeneral.templateNameOpened
                    )
                    scrollToRef(templateRef, formContentRef)
                  }}
                />
              </HideOnMobile>
              <CreateOfferMenu
                isLoading={offerFormGeneral.state === API_STATES.IN_PROGRESS}
                active={
                  hasAvailableVisibilityOptions &&
                  valid &&
                  offerFormGeneral.state !== API_STATES.IN_PROGRESS
                }
                createOffer={createGeneralOffer}
                createBulkOffers={createBulkGeneralOffers}
                createAndDuplicateOffer={createAndDuplicateGeneralOffer}
                createAndStartNewOffer={createAndStartNewGeneralOffer}
              >
                {intl.formatMessage({ id: 'forms.addOffer' })}
              </CreateOfferMenu>
            </ActionGroup>
          </FormActionBar>
        </FormSection>
        <Drafts
          fillFormUsingTemplate={fillFormUsingTemplateGeneral}
          opened={templatesOpened}
          onClose={() => setTemplatesOpened(false)}
          lastOffers={lastOffersGeneral}
          templates={offerTemplatesGeneral}
          removeTemplate={removeTemplateGeneral}
        />
      </Content>
    </Page>
  )
}

const ConnectedComponent = compose(
  connect,
  connectDictionaries
)(OfferFormGeneralCargo)

const CheckboxSectionStyled = styled(CheckboxSection)`
  ${breakpoint.m`
    margin-bottom: 330px;
  `}
`

export default styled(ConnectedComponent)``
